// == Temporal ==
export const SECOND = 1000 // in milliseconds
export const MINUTE = 60 * SECOND

// == Binary measures ==

export const KIBI = 2 ** 10
export const MEBI = 2 ** 20
